import { useUserFeatures } from "../../../../components/contexts/UserFeaturesContext";

export const useTransactionEnrichmentEnabled = (): boolean =>
  Boolean(useUserFeatures().transaction_enrichment);
